import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Advertise() {
  const [f, setF] = useState({ name: "", company: "", email: "", interest: "Sponsored Articles", message: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/advertise", f); toast.success(data.message); setSent(true); }
    catch { toast.error("Could not submit. Please try again."); }
  };
  const options = ["Sponsored Articles","Partner Content","Company Profiles","Newsletter Sponsorship","Display Advertising","Research Sponsorship"];
  return (
    <div className="max-w-[1000px] mx-auto px-4 sm:px-6 py-12">
      <div className="border-b-2 border-ink pb-3 mb-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">Commercial</div>
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink mt-1">Advertise With Us</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <p className="text-ink2 leading-relaxed">The Fin Desk reaches decision-makers across fintech, payments, banking and financial infrastructure. We offer a range of transparent commercial formats — all clearly disclosed and held to our editorial standards.</p>
          <div className="mt-6 space-y-3">
            {options.map((o) => <div key={o} className="border-l-2 border-crimson pl-3 py-1"><div className="font-semibold text-ink">{o}</div></div>)}
          </div>
          <p className="text-xs text-mutedink mt-6">Sponsored and partner content is always clearly labelled. Pricing is shared on enquiry.</p>
        </div>
        <div>
          {sent ? (
            <div className="border border-hair p-8 bg-subtle text-center"><h3 className="font-serif text-2xl">Thank you</h3><p className="text-ink2 mt-2 text-sm">Our commercial team will be in touch shortly.</p></div>
          ) : (
          <form onSubmit={submit} className="space-y-4 border border-hair p-6 bg-surface" data-testid="advertise-form">
            <Field label="Name"><input required value={f.name} onChange={set("name")} data-testid="advertise-name" className="tfd-input" /></Field>
            <Field label="Company"><input value={f.company} onChange={set("company")} data-testid="advertise-company" className="tfd-input" /></Field>
            <Field label="Email"><input type="email" required value={f.email} onChange={set("email")} data-testid="advertise-email" className="tfd-input" /></Field>
            <Field label="Interest">
              <select value={f.interest} onChange={set("interest")} data-testid="advertise-interest" className="tfd-input">
                {options.map((o) => <option key={o}>{o}</option>)}
              </select>
            </Field>
            <Field label="Message"><textarea rows={4} value={f.message} onChange={set("message")} data-testid="advertise-message" className="tfd-input" /></Field>
            <button className="w-full bg-crimson hover:bg-crimsonhover text-white py-3 text-sm font-semibold uppercase tracking-wider" data-testid="advertise-submit">Submit Enquiry</button>
          </form>)}
        </div>
      </div>
      <style>{`.tfd-input{width:100%;border:1px solid #E2DDD5;padding:0.65rem 0.8rem;font-size:0.9rem;outline:none;background:#fff}.tfd-input:focus{border-color:#901321}`}</style>
    </div>
  );
}
function Field({ label, children }) {
  return <label className="block"><span className="text-xs font-bold uppercase tracking-widest text-ink2 mb-1 block">{label}</span>{children}</label>;
}
